import gql from "graphql-tag"

const PlatformMetrics = gql`
  query PlatformMetrics($tenantId: ID!) {
    platformMetrics(tenantId: $tenantId) {
      tenant {
        id
        name
        logged_in_rate
        logged_in_users
        assigned_licenses
        deactivated_users
        last_updated_date
        team_count
        total_savings
        teams {
          name
          id
          logged_in_users
          assigned_licences
          logged_in_rate
          admins
          team {
            teamState
            users {
              total
            }
          }
        }
      }
    }
  }
`

export default PlatformMetrics
